import React from 'react';
import PublicLayout from '../components/PublicLayout';
import { Shield, Lock, Key, Eye, Database, CheckCircle } from 'lucide-react';

const Security = () => {
  const securityFeatures = [
    {
      icon: Lock,
      title: "End-to-End Encryption",
      description: "All data transmitted between your device and our servers is encrypted using industry-standard SSL/TLS protocols."
    },
    {
      icon: Key,
      title: "Secure Authentication",
      description: "JWT-based authentication with secure password hashing ensures your account stays protected."
    },
    {
      icon: Database,
      title: "Data Protection",
      description: "Your personal information is stored in secure, redundant databases with regular backups."
    },
    {
      icon: Eye,
      title: "Privacy Controls",
      description: "You have full control over your data with granular privacy settings and the ability to export or delete your information."
    },
    {
      icon: CheckCircle,
      title: "Regular Audits",
      description: "Our systems undergo regular security audits and penetration testing to identify and address vulnerabilities."
    },
    {
      icon: Shield,
      title: "GDPR Compliant",
      description: "We comply with international data protection regulations including GDPR to ensure your rights are protected."
    }
  ];

  return (
    <PublicLayout>
      <div className="public-page">
        {/* Hero Section */}
        <div className="public-page-header">
          <h1>Your Security is Our Priority</h1>
          <p>
            We implement industry-leading security measures to protect your data and ensure your privacy.
          </p>
        </div>

        <div className="public-page-content">
          {/* Security Features Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
            {securityFeatures.map((feature, index) => {
              const Icon = feature.icon;
              return (
                <div key={index} className="dashboard-card">
                  <Icon className="w-12 h-12 mb-4" style={{color: 'var(--gold)'}} />
                  <h3 style={{fontFamily: 'var(--font-heading)', fontSize: '1.5rem', marginBottom: '1rem'}}>{feature.title}</h3>
                  <p style={{color: 'var(--muted)'}}>{feature.description}</p>
                </div>
              );
            })}
          </div>

          {/* Additional Info */}
          <div className="dashboard-card mb-16">
            <h2 style={{fontFamily: 'var(--font-heading)', fontSize: '2.5rem', marginBottom: '1.5rem'}}>Our Commitment to Security</h2>
            <div className="space-y-4">
              <p style={{color: 'var(--muted)', fontSize: '1.125rem', lineHeight: '1.8'}}>
                At Success Club, we understand that your trust is paramount. That's why we've built our platform with security at its core, implementing multiple layers of protection to safeguard your personal information and business data.
              </p>
              <p style={{color: 'var(--muted)', fontSize: '1.125rem', lineHeight: '1.8'}}>
                Our security team continuously monitors for threats and updates our systems to address emerging vulnerabilities. We also provide transparency through regular security reports and maintain open communication channels for security concerns.
              </p>
            </div>
          </div>

          {/* Contact Section */}
          <div className="text-center rounded-2xl p-12" style={{background: 'var(--dark-bg)', color: '#fff'}}>
            <h2 className="mb-4" style={{color: '#fff', fontFamily: 'var(--font-heading)', fontSize: '3rem'}}>Questions About Security?</h2>
            <p className="text-xl mb-8 max-w-2xl mx-auto" style={{color: 'rgba(255,255,255,0.8)'}}>
              Our security team is here to address any concerns you may have.
            </p>
            <a 
              href="mailto:security@oursuccessclub.com"
              className="btn-primary inline-block no-underline"
            >
              Contact Security Team
            </a>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
};

export default Security;